import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-send-confirm-dialog',
  templateUrl: './send-confirm-dialog.component.html',
  styleUrls: ['./send-confirm-dialog.component.scss']
})
export class SendConfirmDialogComponent implements OnInit {

  public title = 'Confirmation d\'envoi';
  public message = 'Veuillez confirmer l\'envoi du message';
  public cancelbutton = 'Annuler';
  public sendbutton = 'Confirmer';
  protected sendstatus = 'send';

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<SendConfirmDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data !== null)
    {
      this.title = data.title || this.title;
      this.message = data.message || this.message;
      this.cancelbutton = data.cancelbutton || this.cancelbutton;
      this.sendbutton = data.sendbutton || this.sendbutton;
      this.sendstatus = data.sendstatus || this.sendstatus;
    }
  }

  ngOnInit(): void {
  }

  startSend()
  {
    this.dialogRef.close(this.sendstatus);
  }
}
